import { useShowSubscriptionCancelledDialog } from 'shared/errors/data/useShowSubscriptionCancelledDialog';
import {
  EXPERIMENT_TYPES,
  fetchExperiments,
} from 'shared/modules/experiments/ExperimentsAPI';
import { useSubscriptionDetailsMutation } from 'shared/modules/subscription/SubscriptionAPI';
import {
  redirectToURL,
  useRedirectToTMSLanding,
} from 'shared/routing/TMSLandingPath';

export function useSubscriptionFetchExpirement() {
  const subscriptionDetails = useSubscriptionDetailsMutation();

  const { redirectToTMSLanding, isPending: isRedirectPending } =
    useRedirectToTMSLanding();

  const { setOpenSubscriptionCancelledDialog } =
    useShowSubscriptionCancelledDialog();

  const handleFetchExperiment = () => {
    void subscriptionDetails.mutateAsync(undefined).then((subscriptionData) => {
      const isSubscriptionOnLitePlan =
        subscriptionData.data.subscription?.plan?.name === 'lite';
      const hasCustomerCardDetails =
        subscriptionData.data.customer?.payment_method;

      if (isSubscriptionOnLitePlan && hasCustomerCardDetails) {
        setOpenSubscriptionCancelledDialog('cancelled');
        redirectToURL('/loadboard');
      } else if (isSubscriptionOnLitePlan && !hasCustomerCardDetails) {
        setOpenSubscriptionCancelledDialog('expired');
        redirectToURL('/loadboard');
      } else {
        void fetchExperiments().then((data) => {
          const redirectToSLBExperiment = data.data.groups.find(
            (e) => e.number === EXPERIMENT_TYPES['Redirect To SLB'],
          );

          if (redirectToSLBExperiment?.seen) {
            redirectToURL('/loadboard');
          } else {
            redirectToTMSLanding();
          }
        });
      }
    });
  };
  return {
    handleFetchExperiment,
    isLoading: subscriptionDetails.isPending || isRedirectPending,
  };
}
